import React from 'react';

function FacebookCircleIcon() {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4901 24.9801C19.3881 24.9801 24.9801 19.3881 24.9801 12.4901C24.9801 5.59199 19.3881 0 12.4901 0C5.59199 0 0 5.59199 0 12.4901C0 19.3881 5.59199 24.9801 12.4901 24.9801ZM13.6711 13.1555V20.106H10.8716V13.1555H8.5298V10.4466H10.8716V8.45021C10.8716 6.13789 12.2848 4.87417 14.3575 4.87417C15.3467 4.87417 16.2013 4.94811 16.4503 4.98172V7.4016H15.017C13.8864 7.4016 13.6711 7.93263 13.6711 8.71909V10.4466H16.3561L16.0062 13.1555H13.6711Z"
            />
        </svg>
    );
}

export default FacebookCircleIcon;
